<template>
    <Dialog v-model="show" @input="$listeners.input" :title="title" width="400"
            @close="fecharDialog">
        <div class="col justify-center">
            <div class="mt-4">
                <p>Você tem certeza que deseja voltar a etapa selecionada?</p>
            </div>
            <div class="d-flex justify-end" style="gap: 10px;">
                <v-btn style="width: 100px;" class="transition" color="secondary" rounded @click="fecharDialog">
                    Não
                </v-btn>
                <v-btn style="width: 100px;" class="transition" color="primary" rounded @click="confirm">
                    Sim
                </v-btn>
            </div>
        </div>
    </Dialog>
</template>

<script>

  export default {
    name: 'DialogVoltarEtapas',
    props: {
      value: { type: Boolean, default: false },
      showCloseButton: { type: Boolean, default: true }
    },
    data: () => ({
      title: 'ATENÇÃO!'
    }),
    computed: {
      show: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
        }
      }
    },
    methods: {
      fecharDialog () {
        this.show = false
      },

      confirm () {
        this.$emit('confirm')
        this.fecharDialog()
      }

    }
  }
</script>
